import React ,{useEffect, useState}from "react";
import { Grid, Box, Typography, Link } from "@mui/material";
import { useTranslation } from "react-i18next";
import { GENETIC_FINDINGS_CNV_GERMLINE, GENETIC_FINDINGS_CNV_SOMATIC } from "./config/genetic_findings_cnv.js";
import { GENETIC_FINDINGS_SNV_GERMLINE, GENETIC_FINDINGS_SNV_SOMATIC } from "./config/genetic_findings_snv.js";
import { GENETIC_FINDINGS_FUSIONS } from "./config/genetic_findings_fusions.js";
import GeneralTable from "../../../create-report/shared-components/general-table/GeneralTable.js";
import MappedText from "../../shared-components/mapText.js";



export default function GeneticFindingsReport({data, handleUpdate, report_id, variant_type, analysisType}) {
    const [sectionData, setData] = useState(data)
    const { t, i18n } = useTranslation();
    
    // Translate sectionData for display when language or data changes
    const translatedData = React.useMemo(() => {
        if (!sectionData || !Array.isArray(sectionData)) return sectionData;
        
        // Get translation bundle for current language (skip if English, as it's the default)
        const currentLang = i18n.language;
        if (currentLang === 'en') return sectionData;
        
        const translationBundle = i18n.getResourceBundle(currentLang, 'translation');
        if (!translationBundle) return sectionData;
        
        return sectionData.map(row => {
            const translatedRow = { ...row };
            // Translate significance if translation exists
            if (translatedRow.significance && translationBundle[translatedRow.significance]) {
                translatedRow.significance = translationBundle[translatedRow.significance];
            }
            // Translate zygosity if translation exists
            if (translatedRow.zygosity && translationBundle[translatedRow.zygosity]) {
                translatedRow.zygosity = translationBundle[translatedRow.zygosity];
            }
            // Translate origin if translation exists
            if (translatedRow.origin && translationBundle[translatedRow.origin]) {
                translatedRow.origin = translationBundle[translatedRow.origin];
            }
            return translatedRow;
        });
    }, [sectionData, i18n.language, i18n]);
    
    let columns;

    if (variant_type === "Gene Fusion") {
        columns = GENETIC_FINDINGS_FUSIONS;
      } else if (variant_type === "CNV") {
        columns =
          analysisType === "germline"
            ? GENETIC_FINDINGS_CNV_GERMLINE
            : GENETIC_FINDINGS_CNV_SOMATIC;
      } else {
        columns =
          analysisType === "germline"
            ? GENETIC_FINDINGS_SNV_GERMLINE
            : GENETIC_FINDINGS_SNV_SOMATIC;
      }

    const handleSelectedRows = (rows) => {
        let rowsData = rows.map(s => s.original);
        let obj= {rows: rowsData}
        handleUpdate(obj, variant_type);
    };

    useEffect(() => {
        setData(data);
    }, [data]);

    
    return (
        <Grid item xs={12}>
            <Box p={1}>
                <Box>
                    <GeneralTable data={translatedData} columns={columns} showCheckbox={true} handleSelectedRows={handleSelectedRows} />
                    {(analysisType !== "somatic_fusion_analysis") && (
                        <Typography variant='caption' display={"flex"}><MappedText text="*Based upon reference genome version GRCh38" /></Typography>
                    )}
                    {(analysisType !== "germline" && analysisType === "somatic_fusion_analysis") && (
                        <Typography variant='caption' display={"flex"}>
                            <MappedText text="**Based upon ClinGen, CGC and VICC recommendations (Horak et al. 2022)" />
                        </Typography>
                    )}
                    {(analysisType === "germline" ) && (
                        <Typography variant='caption' display={"flex"}>
                            <MappedText text="**Based upon ACMG and ClinGen recommendations (Richards et al. 2015 and  " /> <span>&nbsp;</span>
                            <Link href="https://www.clinicalgenome.org" target="_blank" rel="noopener noreferrer"> ClinGen)</Link>
                        </Typography>
                    )}
                </Box>
            </Box>
        </Grid>
    );
}
